<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>职员档案管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="所属机构：">
                <el-input size="small" v-model="formInline.organizationName" :disabled="true"
                    placeholder="请输入机构名称"></el-input>
            </el-form-item>
            <el-form-item label="所属部门">
                <el-cascader :options="deptTreeList" v-model="formInline.deptIds" clearable filterable
                    :show-all-levels="false" :props="{
                        label: 'deptName', value: 'deptId',
                        checkStrictly: true,
                        emitPath: false,
                    }"></el-cascader>
            </el-form-item>
            <el-form-item label="岗位：">
                <el-input size="small" v-model="formInline.stationLike" placeholder="请输入岗位名称"></el-input>
            </el-form-item>
            <el-form-item label="工号：">
                <el-input size="small" v-model="formInline.workNoLike" placeholder="请输入工号名称"></el-input>
            </el-form-item>
            <el-form-item label="姓名：">
                <el-input size="small" v-model="formInline.userNameLike" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item>
                <div class="d-flex flex-align-center">
                    <el-button size="small" type="primary" @click="search()">搜索</el-button>
                    <el-button size="small" type="primary" @click="handleEdit()"
                        v-buttonAuth="'system:employee:add'">添加</el-button>
                    <el-button size="small" type="primary" @click="dropdownBtn()"
                        v-buttonAuth="'system:employee:download'">下载模版</el-button>
                    <el-button size="small" type="primary" @click="showExportDialog()" plain
                        v-buttonAuth="'system:employee:export'">导入</el-button>
                </div>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="customColumns" :tableData="tableData" :loading="isLoading">
                <el-table-column align="center" prop="userSex" label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEdit(1, scope.row)"
                            v-buttonAuth="'system:employee:edit'">编辑</el-button>
                        <el-button size="mini" type="text" class="col-666" @click="handleEdit(2, scope.row)"
                            v-buttonAuth="'system:employee:details'">详情</el-button>
                        <!-- <el-button size="mini" type="text" class="col-666" v-buttonAuth="'system:employee:records'"
                            @click="showTrainDialog(scope.row)">培训记录</el-button> -->
                        <el-button size="mini" type="text" class="col-666" v-buttonAuth="'system:employee:safe'"
                            @click="downLoadWord(scope.row)">安全培训教育档案</el-button>
                        <!-- <el-popconfirm title="确认删除吗？" @confirm="deleteRow(scope.$index, scope.row)">
                            <el-button type="text" slot="reference" class="col-f4d"
                                v-buttonAuth="'system:employee:delete'">删除</el-button>
                        </el-popconfirm> -->
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" :close-on-click-modal="false"
            custom-class="form-dialog" width="70%" @close='closeDialog("edit")'>
            <my-form :form-config="formConfig.formItems" ref="editForm" :disable-form="formConfig.disabled"
                :formRules="formConfig.formRules" @submit="submitForm" :dataForm="formConfig.dataForm">

                <template #avatar>
                    <my-upload v-bind="property" :imgUrl="formConfig.dataForm.avatar"
                        @upload-success="handleSuccessAvatar" @beforeUpload="beforeUpload"
                        @upload-remove="handleRemoveAvatar">
                        <div slot="tip">
                            <span style="color:red;">注：</span>
                            1、正常照片标准：彩色免冠照片，人脸正面居中，头部占照片2/3，头发扎起，刘海拉起，摘下眼镜，眉毛、五官无遮挡，面部表情自然，光线适中，图像清晰，无过度美化，纯色背景颜色，照片像素480*640
                            <像素<1080*1920，jpg格式，大小不超过80K。 <p>2、可能无法识别的照片：低头、抬头、侧脸、遮挡五官、表情夸张、闭眼、头像太小、过度美化、图像模糊、黑白照片。</p>
                                <p><span style="color:red;">注：</span>
                                    <img src="@/assets/img/person.png" @click="dialogVisible = true;"
                                        style="    vertical-align: top;width: 100px;cursor: pointer;" />
                                </p>
                        </div>
                    </my-upload>
                </template>

                <template #signature>
                    <my-upload v-bind="property" :imgUrl="formConfig.dataForm.signature"
                        @upload-success="handleSuccessSigna" @beforeUpload="beforeUpload"
                        @upload-remove="handleRemoveSigna">">
                        <div slot="tip">
                            <span style="color:red;">注：</span>
                            上传图片像素小于等于500*400像素
                        </div>
                    </my-upload>
                </template>
            </my-form>
            <div slot="footer" class="dialog-footer" v-if="!formConfig.disabled
            ">
                <el-button size="small" @click='editFormVisible = false;'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible" width="50%">
            <img width="100%" src="@/assets/img/person.png" alt="">
        </el-dialog>

        <!-- 导入 -->
        <my-import-dialog :exportUploadProperty="exportUploadProperty" :visible="exportDialog.visible" :file-size="100"
            :getResult="exportRes" @close="closeExportDialog"></my-import-dialog>
        <!-- 培训记录 -->
        <el-dialog :title="trainingDialog.title" :visible.sync="trainingDialog.visible" :close-on-click-modal="false"
            custom-class="form-dialog" width="70%"
            @close='trainingDialog.visible = false; trainingDialog.formInline.date = []'>
            <el-form :inline="true" size="small" :model="trainingDialog.formInline" class="user-search">
                <el-form-item>
                    <el-date-picker v-model="trainingDialog.formInline.date" value-format='yyyy-MM-dd HH:mm:ss'
                        type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <div class="d-flex flex-align-center">
                        <el-button size="small" type="primary" @click="searchTrain()">搜索</el-button>
                        <el-button size="small" type="primary" @click="exportTrainRec()">导出</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div class="main-table">
                <el-collapse v-model="trainingDialog.activeNames">
                    <el-collapse-item title="公司级安全教育" name="1">
                        <my-table :columns="trainingDialog.customColumns" :tableData="trainingDialog.company"
                            :loading="trainingDialog.isLoading"> </my-table>
                    </el-collapse-item>
                    <el-collapse-item title="车间级安全教育" name="2">
                        <my-table :columns="trainingDialog.customColumns" :tableData="trainingDialog.workshop"
                            :loading="trainingDialog.isLoading"> </my-table>
                    </el-collapse-item>
                    <el-collapse-item title="班组级安全教育" name="3">
                        <my-table :columns="trainingDialog.customColumns" :tableData="trainingDialog.unit"
                            :loading="trainingDialog.isLoading"> </my-table>
                    </el-collapse-item>
                    <el-collapse-item title="其他级安全教育" name="4">
                        <my-table :columns="trainingDialog.customColumns" :tableData="trainingDialog.other"
                            :loading="trainingDialog.isLoading"> </my-table>
                    </el-collapse-item>
                </el-collapse>

            </div>

        </el-dialog>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import { organizationName, fileDownload, downloadFile, numberDesensitization } from "@/utils/util.js";
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import MyUpload from "@/components/myUpload.vue";
import { deptTree } from '@/api/dept.js'
import { archivePage, archiveAdd, archiveEdit, archiveDetail, archiveInfoExport, archiveRemove, importRes, trainRecQuery, exportTrainRec } from '@/api/employee.js'
import myImportDialog from "@/components/myImportDialog.vue";
import { exportWord, getBase64Sync } from '@/utils/exportDocx';

export default {
    components: {
        MyTable,
        Pagination,
        myForm,
        MyUpload,
        myImportDialog
    },
    data () {

        return {
            formInline: {
                organizationName: organizationName,
                deptIds: ''
            },
            customColumns: [
                { label: '所属机构', prop: 'name', formatter: () => { return organizationName } },
                { label: '姓名', prop: 'userName' },
                { label: '所属部门', prop: 'deptName' },
                { label: '岗位', prop: 'station' },
                { label: '账号', prop: 'accountNo' },
                { label: '工号', prop: 'workNo' },
                { label: '在职状态', prop: 'onJob', formatter: (item) => { return item ? '在职' : '离职' } },
                { label: '性别', prop: 'sex', formatter: (item) => { return item == 'male' ? '男' : item == 'female' ? '女' : '-' } }
            ],
            isLoading: false,
            dialogVisible: false,
            dialogImageUrl: '',
            tableData: [
            ],
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            editFormVisible: false, //控制编辑页面显示与隐藏
            title: '添加用户',
            deptTreeList: [],
            // 编辑与添加
            formConfig: {
                formItems: [
                    { type: 'input', prop: 'userName', label: '姓名:', span: 8, },
                    {
                        type: 'select', prop: 'sex', label: '性别:', span: 8, options: [{ id: 'male', label: '男' }, { id: 'female', label: '女' }]
                    },
                    { type: 'input', prop: 'workNo', label: '工号:', span: 8, },
                    { type: 'input', prop: 'accountNo', label: '账号:', span: 8, },
                    {
                        type: 'input', prop: 'organizationName', label: '所属机构:', span: 8,
                        disable: true
                    },
                    {
                        type: 'cascader', prop: 'deptId', label: '所属部门:', span: 8, options: []
                        , property: {
                            clearable: true,
                            filterable: true,
                            'show-all-levels': false,
                            props: {
                                label: 'deptName', value: 'deptId',
                                checkStrictly: true,
                                emitPath: false,

                            }

                        },
                    },
                    {
                        type: 'input', prop: 'station', label: '所属岗位:', span: 8,
                    },
                    { type: 'input', prop: 'nativePlace', label: '籍贯:', span: 8, },
                    { type: 'input', prop: 'idCard', label: '身份证号:', span: 8, },
                    { type: 'date', prop: 'birthday', label: '出生日期:', span: 8, },
                    { type: 'date', prop: 'workStartDay', label: '参加工作时间:', span: 8, },



                    {
                        type: 'select', prop: 'politicalOutlook', label: '政治面貌:', span: 8, options: [
                            { id: '中国共产党党员', label: '中国共产党党员' },
                            { id: '中国共产主义青年团团员', label: '中国共产主义青年团团员' },
                            { id: '群众', label: '群众' },
                        ]
                    },
                    { type: 'date', prop: 'partyStartDay', label: '入党(团)时间:', span: 8, },
                    { type: 'input', prop: 'partyLeader', label: '上级党委:', span: 8, },
                    { type: 'input', prop: 'partyBranch', label: '所在党支部:', span: 8, },

                    {
                        type: 'select', prop: 'eduLev', label: '最高学历:', span: 8, options: [
                            { id: '小学', label: '小学' },
                            { id: '初中', label: '初中' },
                            { id: '高中/职高/中专', label: '高中/职高/中专' },
                            { id: '专科', label: '专科' },
                            { id: '本科', label: '本科' },
                            { id: '硕士', label: '硕士' },
                            { id: '博士', label: '博士' },
                        ]
                    },
                    { type: 'input', prop: 'graduateSchool', label: '毕业院校及专业:', span: 8, },

                    {
                        type: 'select', prop: 'onJob', label: '在职状态:', span: 8, options: [
                            { id: true, label: '在职' },
                            { id: false, label: '离职' },
                        ]
                    },
                    {
                        type: 'select', prop: 'onProbation', label: '是否在试用期:', span: 8, options: [
                            { id: true, label: '是' },
                            { id: false, label: '否' },
                        ]
                    },
                    { type: 'input', prop: 'specialType', label: '专业技术类别:', span: 8, },
                    { type: 'input', prop: 'specialName', label: '专业技术职称:', span: 8, },
                    { type: 'input', prop: 'specialLev', label: '专业技术职称级别:', span: 8, },
                    { type: 'input', prop: 'specialDay', label: '取得专业技术职称时间:', span: 8, },
                    { type: 'input', prop: 'independentOperationScore', label: '独立操作成绩:', span: 8 },
                    { prop: 'avatar', slot: 'upload', label: '上传本人照片:', span: 24, },
                    { prop: 'signature', slot: 'upload', label: '本人签字:', span: 24, },
                ],
                formRules: {
                    partyStartDay: {},
                    partyLeader: {},
                    partyBranch: {},
                    userName: { required: true, message: '请输入姓名', trigger: 'blur' },
                    sex: { required: true, message: '请选择性别', trigger: 'change' },
                    workNo: { required: true, message: '请输入工号', trigger: 'blur' },
                    organizationName: { required: true, message: '请输入所属机构', trigger: 'blur' },
                    accountNo: [
                        { required: true, message: '请输入账号/手机号', trigger: 'blur' },
                        { pattern: /^1[123456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                    ],
                    deptId: { required: true, message: '请选择部门', trigger: 'change' },
                    station: { required: true, message: '请输入岗位', trigger: 'blur' },
                    idCard: [
                        { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号格式不正确', trigger: 'blur' }
                    ],
                    // politicalOutlook: { required: true, message: '请选择政治面貌', trigger: 'change' },
                    onJob: { required: true, message: '请选择在职状态', trigger: 'change' },
                    onProbation: { required: true, message: '请选择是否在试用期', trigger: 'change' },
                    avatar: {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请上传本人照片'));
                            }
                            callback();
                        }, trigger: 'change'
                    },
                    // signature: { required: true, message: '请上传本人签字', trigger: 'change' },
                },
                dataForm: {
                    organizationName: organizationName,
                    avatar: '',
                    signature: '',
                    politicalOutlook: '',
                }
            },
            property: {
                config: {
                    customAction: "/api/file/upload", // 替换成你的上传地址
                    accept: '.png,.jpg,jpeg',
                    listType: 'picture',
                    showFileList: false,
                    headers: {
                    },
                    disabled: false,
                    limit: 1,
                    uploadData: {
                        // 可选的上传数据
                    },
                    yourValue: [], // 双向绑定的值
                },
            },
            exportUploadProperty: {
                config: {
                    customAction: "/api/sys/sys-archive/import", // 替换成你的上传地址
                    accept: '.xls,.xlsx',
                    headers: {
                    },
                    disabled: false,
                    limit: 1,
                    uploadData: {
                        // 可选的上传数据
                    },
                    yourValue: [], // 双向绑定的值
                },
            },
            exportDialog: {
                visible: false,
            },
            trainingDialog: {
                title: '培训记录',
                userItem: {},
                visible: false,
                company: [],
                workshop: [],
                unit: [],
                other: [],
                formInline: {
                    date: [],
                },
                activeNames: ['1', '2', '3', '4'],
                isLoading: false,
                customColumns: [
                    { label: '任务名称', prop: 'planName' },
                    { label: '课程名称', prop: 'courseName' },
                    { label: '课程学习时长', prop: 'studyTimesText' },
                    { label: '是否合格', prop: 'passSign', formatter: (item) => { return item ? '合格' : '不合格' } },
                    { label: '试卷名称', prop: 'examName' },
                    { label: '及格分', prop: 'passScore' },
                    { label: '及格题目数', prop: 'passNum' },
                    { label: '得分', prop: 'examScore' },
                    { label: '正确数量', prop: 'examCorrectCount' },
                ],
                page: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                }
            },


        }
    },
    watch: {
        'formConfig.dataForm.politicalOutlook': {
            handler (val) {
                this.formConfig.formRules.partyStartDay = {};
                this.formConfig.formRules.partyLeader = {};
                this.formConfig.formRules.partyBranch = {};
                // if (val == '中国共产党党员') {
                //     this.formConfig.formRules.partyStartDay = { required: true, message: '请选择入党时间', trigger: 'change' };
                //     this.formConfig.formRules.partyLeader = { required: true, message: '请填写上级党委', trigger: 'change' };
                //     this.formConfig.formRules.partyBranch = { required: true, message: '请填写所在党支部', trigger: 'change' };
                // } else if (val == '中国共产主义青年团团员') {
                //     this.formConfig.formRules.partyStartDay = { required: true, message: '请选择入党时间', trigger: 'change' };
                // }
                this.$forceUpdate();
                if (val) {
                    setTimeout(() => {
                        this.$refs.editForm.$refs.form.validateField('partyStartDay');
                        this.$refs.editForm.$refs.form.validateField('partyLeader');
                        this.$refs.editForm.$refs.form.validateField('partyBranch');
                    }, 500);
                }
            }
        }
    },
    created () {
        this.getDeptList();
        this.getData();
    },
    methods: {
        search () {
            this.pageparm.currentPage = 1;
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
            }
            if (this.formInline.deptIds) {
                params.deptIds = [this.formInline.deptIds]

            } else {
                delete params.deptIds
            }
            const res = await archivePage(params);
            this.tableData = res.data.records;
            this.pageparm.total = res.data.total;
        },
        beforeUpload (rawFile, fun) {
            const get = _ => {
                if (!rawFile.name.includes('png') && !rawFile.name.includes('jpg') && !rawFile.name.includes('jpeg')) {
                    this.$store.state.loading = false;
                    this.$message({ message: '请上传正确的格式！', type: 'error' })
                    return false;
                } else if (rawFile.size / 1024 / 1024 > 5) {
                    this.$store.state.loading = false;
                    this.$message({ message: '超过5MB上传大小！', type: 'error' })
                    return false;
                }
                return true;
            };
            fun(get());
        },
        handleSuccessSigna (data, file) {
            this.formConfig.dataForm.signature = envConfig.NODE_IMG_API + data.data.fileKey
            this.$refs.editForm.$refs.form.validateField('signature');
            this.$store.state.loading = false;
        },
        handleRemoveSigna (file, fileList) {
            this.formConfig.dataForm.signature = ''
        },
        handleSuccessAvatar (data, file) {
            this.formConfig.dataForm.avatar = envConfig.NODE_IMG_API + data.data.fileKey;
            this.$refs.editForm.$refs.form.validateField('avatar');
            this.$store.state.loading = false;
        },
        handleRemoveAvatar (file, fileList) {
            this.formConfig.dataForm.avatar = ''
        },
        async getDeptList () {
            const res = (await deptTree({ pageNum: 1, pageSize: 99999 })).data;
            this.formConfig.formItems[5].options = res;
            this.deptTreeList = res
        },
        handleEdit (index, row) {
            this.property.config.disabled = false;
            this.formConfig.disabled = false;
            this.editFormVisible = true
            if (row != undefined && row != 'undefined') {
                this.title = '修改用户';
                this.formConfig.dataForm = row;
                this.formConfig.dataForm.organizationName = organizationName;
                // this.formConfig.dataForm.deptId = [row.deptId];
                this.formConfig.dataForm.avatar = row.avatar && row.avatar != 'null' ? envConfig.NODE_IMG_API + row.avatar : '';
                this.formConfig.dataForm.signature = row.signature && row.signature != 'null' ? envConfig.NODE_IMG_API + row.signature : '';

                if (index == 2) {
                    this.title = '查看用户';
                    this.property.config.disabled = true;
                    this.formConfig.disabled = true;
                }

            } else {
                this.title = '添加用户';
                this.formConfig.dataForm = {
                    organizationName: organizationName,
                    avatar: '',
                    signature: '',
                };
                if (this.$refs.editForm) {
                    this.$refs.editForm.$refs.form.resetFields();
                }
            }
        },

        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize;
            this.getData()
        },
        // 关闭编辑、增加弹出框
        closeDialog (dialog) {
            this.$refs.editForm.$refs.form.resetFields();
            this.$store.state.loading = false;
            this.editFormVisible = false;
            this.getData()
        },
        submitForm (editData) {
            let data = JSON.parse(JSON.stringify(this.formConfig.dataForm));
            this.$refs.editForm.$refs.form.validate(async valid => {
                if (valid) {
                    data.avatar = data.avatar ? data.avatar.replace('/resource', '') : null;
                    data.signature = data.signature ? data.signature.replace('/resource', '') : null;
                    // data.deptId = this.formConfig.dataForm.deptId.join();
                    const res = await (data.archiveId ? archiveEdit(data) : archiveAdd(data));
                    this.closeDialog();
                    await this.getData();
                    this.$message.success(res.msg);
                } else {
                    return false
                }
            })
        },

        dropdownBtn (index, data) {
            fileDownload(envConfig.NODE_API + '/templates/员工档案批量导入模板.xlsx', '员工档案批量导入模板.xlsx');
        },
        async deleteRow (index, row) {
            const archiveRes = await archiveRemove([row.archiveId]);
            this.$message.success(archiveRes.msg);
            this.getData();
        },
        showExportDialog () {
            this.exportDialog.visible = true
            this.exportDialog.tableData = { total: 0, failCnt: 0 };
            this.exportUploadProperty.config.yourValue = [];
        },
        closeExportDialog () {
            this.exportDialog.visible = false;
            this.getData();
            this.exportUploadProperty.config.yourValue = [];
        },
        exportRes () {
            return importRes()
        },
        searchTrain () {
            this.showTrainDialog(this.trainingDialog.userItem)
        },
        async showTrainDialog (row) {
            this.trainingDialog.userItem = row;
            const params = {
                userId: row.userId,

            };
            if (this.trainingDialog.formInline.date && this.trainingDialog.formInline.date.length) {
                params.endTime = this.trainingDialog.formInline.date[1];
                params.startTime = this.trainingDialog.formInline.date[0];
            };
            this.trainingDialog.loading = true;
            const res = await trainRecQuery(params)
            this.trainingDialog.loading = false;
            this.trainingDialog.company = res.data.company || [];
            this.trainingDialog.workshop = res.data.workshop || [];
            this.trainingDialog.unit = res.data.unit || [];
            this.trainingDialog.other = res.data.other || [];
            this.trainingDialog.visible = true;
        },
        async exportTrainRec () {
            const params = {
                userId: this.trainingDialog.userItem.userId,
            };
            if (this.trainingDialog.formInline.date && this.trainingDialog.formInline.date.length) {
                params.endTime = this.trainingDialog.formInline.date[1];
                params.startTime = this.trainingDialog.formInline.date[0];
            };
            const header = {
                responseType: 'blob',
                isExport: false
            }
            const res = (await exportTrainRec(params, header));
            downloadFile(res, 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', `${this.trainingDialog.userItem.userName}培训记录.xlsx`);
        },
        async getImgBase64 (img) {
            let url = '';
            if (img && img.length > 0) {
                url = await getBase64Sync('/resource' + img)
            }
            if (img == 'null') {
                url = ''
            }
            return url;
        },
        async downLoadWord (item) {
            try {
                const res = await archiveInfoExport(item.archiveId);
                res.data.avatar = await this.getImgBase64(res.data.avatar);
                res.data.signature = await this.getImgBase64(res.data.signature);
                for (const element of res.data.jl) {
                    element.signature = await this.getImgBase64(element.signature);
                }

                for (const element of res.data.sl) {
                    element.signature = await this.getImgBase64(element.signature);
                }
                exportWord('/static/employeeSafetyEducation.docx', res.data, `${item.userName}-安全培训教育档案`, { src: [50, 50] });
            } catch (error) {
                console.error(error);
            }
        }


    }

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}
</style>

<style>
.main-table .el-collapse,
.main-table .el-collapse-item__wrap {
    border-bottom: none;
}

.main-table .el-collapse-item {
    margin-bottom: 10px;
}

.main-table .el-collapse-item__header {
    background-color: #ddfeff;
    padding-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/basicData/employee.vue